<div class="header">
    <div class="header-media">
        <ng-content select="fui-icon"></ng-content>
    </div>
    <div class="header-label">
        <div class="header-label-title" id="label">
            {{label | translate}}
        </div>
    </div>
</div>
<div class="main">
    <ng-content></ng-content>
</div>
